import sutong from './index.vue'
import sutongHome from './Home.vue'

const dehumidifierSmall = () => import('./dehumidifierSmall.vue')
const dehumidifierBig = () => import('./dehumidifierBig.vue')
const emptyComponent = () => import('./emptyRouterComponent.vue')
const gasClamp = ()=> import('./gasClamp.vue')
const airValve = ()=> import('./airValve.vue')
const ventilation = ()=>import('./ventilationNew.vue')
const remoteHistory = ()=>import('./../../components/RemoteHistory.vue')
const dataHistory = () => import('./../../components/DataHistory.vue')
const bridgeImg = () => import('./bridgeImg.vue')
 const login = () => import('./login.vue')

export default [
  {
    path: '/sutongIndex',
    name: 'sutongIndex',
    component: sutongHome
  },
  {
    path: '/sutong/login',
    name: 'sutongLogin',
    component: login
  },
  {
    path: '/sutong',
    name: 'sutong',
    redirect: '/sutong/nantong',
    component: sutong,
    children: [
      {
        path: 'nantong',
        name: 'nantong',
        redirect: '/sutong/nantong/dehumidifierSmall',
        component: emptyComponent,
        children: [
          {
            path: 'dehumidifierSmall',
            name: 'nantongSmall',
            component: dehumidifierSmall
          },
          {
            path: 'dehumidifierBig',
            name: 'nantongBig',
            component: dehumidifierBig
          },
          {
            path: 'ventilation',
            name: 'nantongVentilation',
            component: ventilation
          }
        ]
      },
      {
        path: 'changshu',
        name: 'changshu',
        redirect: '/sutong/changshu/dehumidifierSmall',
        component: emptyComponent,
        children: [
          {
            path: 'dehumidifierSmall',
            name: 'changshuSmall',
            component: dehumidifierSmall
          },
          {
            path: 'dehumidifierBig',
            name: 'changshuBig',
            component: dehumidifierBig
          },
        ]
      },
      {
        path: 'gasClamp',
        name: 'gasClamp',
        component: gasClamp
      },
      {
        path: 'airValve',
        name: 'airValve',
        redirect: '/sutong/airValve/airValveRemote',
        component: emptyComponent,
        children:[
          {
            path: 'airValveRemote',
            name: 'airValveRemote',
            component: airValve
          },
          {
            path: 'remoteHistory',
            name: 'remoteHistory',
            component: remoteHistory
          },
          {
            path: 'airValveSwitch',
            name: 'airValveSwitch',
            component: airValve
          }
        ]
      },
      {
        path: 'ventilation',
        name: 'changshuVentilation',
        component: ventilation
      },
      {
        path: 'bridgeImg',
        name: 'bridgeImg',
        component: bridgeImg
      },
      {
        path: 'dataHistory',
        name: 'sutong_dataHistory',
        component: dataHistory
      },
    ]
  }
]
